import styled from "styled-components"

export interface SplitProps {
  split: boolean
}

export const StyledModal = styled.div<SplitProps>`
  background: ${props => props.theme.colors.white};
  width: 100%;

  max-height: 100%;
  overflow-y: scroll;
  position: relative;
  z-index: 1;

  ${props => props.split && (`
    display: grid;
    grid-template-columns: 50% 50%;
    @media (max-width: ${props.theme.breakPoints.tablet}) {
      grid-template-columns: 100%;
    }
  `)}
`
export const StyledModalInfo = styled.div<SplitProps>`
  width: 100%;
  padding: 32px;
  @media (max-width: ${props => props.theme.breakPoints.tablet}) {
    padding: 24px;
    max-width: 100%;
  }
  @media (max-width: ${props => props.theme.breakPoints.mobile}) {
    padding: 24px 16px;
  }
`
export const StyledModalLogo = styled.img`
  width: 100%;
  max-width: 100px;
`
export const StyledModalTitle = styled.p`
  ${props => props.theme.mixins.h2}
  padding: 24px 0;
`
export const StyledModalContent = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
`
export const StyledModalDescription = styled.div`
  padding-right: 32px;
  @media (max-width: ${props => props.theme.breakPoints.tablet}) {
    padding-right: 24px;
  }

  & p{
    ${props => props.theme.mixins.body}
  }
`
export const StyledModalImage = styled.img`
  width: 100%;
  max-width: 50%;
  @media (max-width: ${props => props.theme.breakPoints.tablet}) {
    max-width: 100px;
  }
`
export const StyledModalForm = styled.div<SplitProps>`
  width: 100%;
  padding: 32px;
  border-top: 1px solid ${props => props.theme.colors.darkGrey10};
  background: ${props => props.split ? props.theme.colors.darkGrey : props.theme.colors.white};
  @media (max-width: ${props => props.theme.breakPoints.tablet}) {
    max-width: 100%;
    padding: 24px 24px 124px;
  }
  @media (max-width: ${props => props.theme.breakPoints.mobile}) {
    padding: 24px 16px 124px;
  }
`
export const StyledModalFormTitle = styled.p<SplitProps>`
  ${props => props.theme.mixins.subsectionTitle}
  color: ${props => props.split ? props.theme.colors.white : props.theme.colors.darkGrey};
  padding: 0 0 24px;
`